import { ReactNode } from "react"

type BaseGrowBodyType = {
    children: ReactNode
    classProps?: string
}
export default function BaseGrowBody(props: BaseGrowBodyType) {
    return <div className={`w-full min-h-0 relative ${props.classProps ? props.classProps : "flex"}`}>{props.children}</div>
}
